export const AutomationType = {
  VARIAVEL: "var",
  PGM: "pgm",
  PGM_IP: "pgm_ip",
};

// Mapeamento para o enum do backend
export const AutomationTypeEnum = {
  [AutomationType.VARIAVEL]: 0,
  [AutomationType.PGM]: 1,
  [AutomationType.PGM_IP]: 2,
};

export const AutomationTypeText = {
  [AutomationType.VARIAVEL]: "Variável de Automação",
  [AutomationType.PGM]: "PGM",
  [AutomationType.PGM_IP]: "PGM IP",
};
